<!--
  --
  -- 支払方法リスト コンポーネント
  --
  -->
<template>
  <div>
    <!-- 読込中 -->
    <template v-if="!payments">
      <div>読込中...</div>
    </template>

      <!-- リストが 0 件 -->
    <template v-else-if="payments.length === 0">
      <div>現在、お支払い方法の登録はありません。</div>
    </template>

    <!-- 支払方法リスト -->
    <template v-else>
      <!-- ヘッダ -->
      <div class="d-flex pl-6 pr-10 caption">
        <div class="flex-grow-1">カード番号</div>
        <div class="pr-4">有効期限</div>
        <div class="w-12 text-center">通常</div>
      </div>

      <!-- リスト -->
      <v-expansion-panels>
        <c-payment-item
          v-for="payment in payments"
          :key="payment.payID"
          :payment="payment"
        >

          <!-- 支払方法への操作 -->
          <template #itemActions>
            <slot name="itemActions" :payment="payment"/>
          </template>

        </c-payment-item>
      </v-expansion-panels>
    </template>
  </div>
</template>

<script>
import CPaymentItem from './CPaymentItem'

export default {
  name: 'CPaymentList',
  components: {
    CPaymentItem
  },
  props: {
    payments: {
      type: Array
    }
  }
}
</script>
